// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".components-Label__Label--pDtSM {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    font-weight: bold;\n}\n\n.components-Label__Text--fswyk {\n    margin-bottom: 0.5rem;\n}\n", "",{"version":3,"sources":["webpack://./src/frontend/components/Label.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB","sourcesContent":[".Label {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    font-weight: bold;\n}\n\n.Text {\n    margin-bottom: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Label": "components-Label__Label--pDtSM",
	"Text": "components-Label__Text--fswyk"
};
export default ___CSS_LOADER_EXPORT___;
